import type { FC, PropsWithChildren } from "react"
import { useFormContext } from "react-hook-form"

import { useAllPowerlineSpans } from "helpers/hooks/spans/useAllPowerlineSpans"
import SpansContext from "./SpansContext"

const SpansProvider: FC<PropsWithChildren> = ({ children }) => {
  const { watch } = useFormContext()
  const powerlineId = watch("powerlineId")

  const { spansByTowerPair, isLoading } = useAllPowerlineSpans({
    powerlineId: powerlineId ? Number(powerlineId) : undefined,
  })

  return (
    <SpansContext.Provider value={{ spansByTowerPair, isLoading }}>
      {children}
    </SpansContext.Provider>
  )
}

export default SpansProvider
